import { render, staticRenderFns } from "./TransactionHistoryCL.vue?vue&type=template&id=6df21db2&scoped=true&"
import script from "./TransactionHistoryCL.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryCL.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryCL.vue?vue&type=style&index=0&id=6df21db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df21db2",
  null
  
)

export default component.exports